import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-modal-arnold',
	templateUrl: './modal-arnold.component.html',
	styleUrls: ['./modal-arnold.component.css']
})
export class ModalArnoldComponent implements OnInit {

	public layers;
	// Selected arnold layer
	public arnoldLayer;
	constructor(
		public dialogRef: MatDialogRef<ModalArnoldComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	close(result) {
		switch (result) {
			case 'ok':
				this.dialogRef.close(this.arnoldLayer);
				break;
			case 'cancel':
			this.dialogRef.close(null);
		}
	}
	ngOnInit() {
		this.layers = this.data.layers;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/lbe-setting/lbe-upload/modal-arnold/modal-arnold.component.ts